// extracted by mini-css-extract-plugin
export default {"footerSocials":"FooterSocials_footerSocials__mkd-F","footerSocialButton":"FooterSocials_footerSocialButton__uEaB+","footerSocialIcon":"FooterSocials_footerSocialIcon__GHbxV"};